import { useState } from "react";
import classNames from "classnames";

import ExpandOrShrinkIcon from "../../UI/DropDown/ExpandOrShrinkIcon";

import "./styles.scss";

const Dropdown = ({ title, selectedItem, items, onItemSelect, fadeEmpty = false }) => {
  const [open, setOpen] = useState(true);

  const faded = fadeEmpty && items.length === 0;

  return (
    <div className="dropdown">
      <div
        className={classNames("dropdown__title", {
          "dropdown__title--faded": faded,
        })}
        onClick={() => setOpen((state) => !state)}>
        {title}({items?.length}) <ExpandOrShrinkIcon expanded={open} collapsed={false} />
      </div>
      {open && items.length > 0 ? (
        <div className="dropdown__items">
          {items.map((item, i) => (
            <div className="dropdown__item" onClick={() => onItemSelect(title, item)} key={i}>
              <p className="dropdown__item__name">{item}</p>
              {selectedItem === item ? <div className="dropdown__item__active" /> : null}
            </div>
          ))}
        </div>
      ) : null}
    </div>
  );
};

export const DropdownThreatHunter = ({
  title,
  selectedItem,
  selectedSub,
  items = [],
  onItemSelect,
  fadeEmpty = false,
}) => {
  const [open, setOpen] = useState(true);

  const faded = fadeEmpty && items.length === 0;

  return (
    <div className="dropdown">
      <div
        className={classNames("dropdown__title", {
          "dropdown__title--faded": faded,
        })}
        onClick={() => setOpen((state) => !state)}>
        {title}({items?.length}) <ExpandOrShrinkIcon expanded={open} collapsed={false} />
      </div>
      {open && items.length > 0 ? (
        <div className="dropdown__items">
          {items.map((item, i) => (
            <div className="dropdown__item" key={i}>
              <p className="dropdown__item__name">{item}</p>
              <div className="sub-dropdown">
                <div
                  className="sub-dropdown__title"
                  onClick={() => onItemSelect(title, item, "Groups")}>
                  Groups
                  {selectedItem === item && selectedSub === "Groups" ? (
                    <div className="dropdown__item__active" />
                  ) : null}
                </div>
                <div
                  className="sub-dropdown__title"
                  onClick={() => onItemSelect(title, item, "Policies")}>
                  Policies
                  {selectedItem === item && selectedSub === "Policies" ? (
                    <div className="dropdown__item__active" />
                  ) : null}
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : null}
    </div>
  );
};

export default Dropdown;
